mutation PrepareStockImageForEdit($input: PrepareStockImageForEditInput!) {
  prepareStockImageForEdit(input: $input) {
    stockImage {
      id
      externalId
      provider
      license
      topicId
      __typename
    }
    originalImageUrl
    canEdit
    isAlreadyLicensed
    __typename
  }
}
